import type { AxiosInstance } from "axios";
import { format } from "date-fns";

export const fetch = async (axios: AxiosInstance, userUuid: string, limit: number, offset = 0) => {
  const resp = await axios.get<FetchResponse>(`items/${userUuid}`, {
    params: {
      limit,
      offset,
      tz: resolveTimezone(),
    },
    withCredentials: true,
  });

  return resp.data.data || [];
};

export const create = (
  axios: AxiosInstance,
  userUuid: string,
  items: { createdAt: Date; entityUuid: string; expiresAt: Date }[],
) =>
  axios.post(
    "/create",
    items.map(({ createdAt, entityUuid, expiresAt }) => ({
      createdAt,
      entitySubType: "article",
      entityType: "node",
      entityUuid,
      expiresAt,
      itemType: "log",
      userUuid,
    })),
    {
      withCredentials: true,
    },
  );

export const removeByUuidAtDate = (axios: AxiosInstance, entityUuid: string, date: string) =>
  axios.post<Response>(
    "/items/delete",
    { entityUuids: [entityUuid] },
    { params: { day: formatDayParameters(date), tz: resolveTimezone() }, withCredentials: true },
  );

export const removeAllAtDate = (axios: AxiosInstance, date: string, userUuid: string) =>
  axios.delete<Response>(`/items/${userUuid}`, {
    params: { day: formatDayParameters(date), tz: resolveTimezone() },
    withCredentials: true,
  });

const resolveTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const formatDayParameters = (date: string) => format(new Date(date), "yyyy-MM-dd");

export type FetchResponse = Response & { data: ReadingHistoryEntity[] };

export type ReadingHistoryEntity = {
  _id: string;
  createdAt: string;
  entitySubType: string;
  entityType: string;
  entityUuid: string;
  expiresAt: string;
  itemType: string;
  userTzOffset: number;
  userUuid: string;
};

export type Response = { msg: string; status: number };
